import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function tooltip(theme: Theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#fff",
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.dropdown,
        },
        arrow: {
          color: "#fff",
        },
      },
    },
  };
}
